module.exports = __webpack_public_path__ + "img/hr-green-croton-00.13dbe526.png";